import { p as proxyCustomElement, H, h, d as Host } from './p-ae815584.js';

const cosmosIconCss = ":host{color:var(--cosmos-icon-color, inherit);display:inline-block;height:var(--cosmos-icon-size, 1em);vertical-align:-0.1551724138em;width:var(--cosmos-icon-size, 1em)}svg,::slotted(svg){display:block;height:100%;width:100%}";
const CosmosIconParcelStyle0 = cosmosIconCss;

const CosmosIconParcel$1 = /*@__PURE__*/ proxyCustomElement(class CosmosIconParcel extends H {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
        this.ariaLabel = undefined;
    }
    getRole() {
        return this.ariaLabel ? 'img' : undefined;
    }
    getAriaHidden() {
        return this.ariaLabel ? false : 'true';
    }
    render() {
        return (h(Host, { key: 'd04bcc6a7abc3666ef62d2f6afe567f903cd334e', role: this.getRole(), "aria-hidden": this.getAriaHidden(), "aria-label": this.ariaLabel }, h("svg", { key: 'f6e118e43e77035a3a52cf7fcd76ff57537e935f', width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", part: "base" }, h("path", { key: '1be76857a9e8b53c1d233a6bbfb25ee33040401e', "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M18.545 6.168 11.3 3.061a.747.747 0 0 0-.59 0L3.455 6.168a.749.749 0 0 0-.455.69v8.285c0 .3.179.572.455.69l7.25 3.107c.01 0 .022 0 .033.006a.663.663 0 0 0 .524 0c.011 0 .023 0 .033-.006l7.25-3.107a.75.75 0 0 0 .455-.69V6.857a.75.75 0 0 0-.455-.689ZM11 4.566l5.346 2.291-.333.143-1.513.65-5.348-2.292L11 4.566Zm-.75 12.547L4.5 14.65V7.995l5.451 2.336.3.128-.001 6.654ZM11 9.15 5.987 7l-.333-.143L7.5 6.065l5.347 2.292L11 9.15Zm6.5 5.5-5.75 2.464V10.46l.3-.128 5.45-2.336v6.654Z", fill: "currentColor" }))));
    }
    static get style() { return CosmosIconParcelStyle0; }
}, [1, "cosmos-icon-parcel", {
        "ariaLabel": [513, "aria-label"]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["cosmos-icon-parcel"];
    components.forEach(tagName => { switch (tagName) {
        case "cosmos-icon-parcel":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, CosmosIconParcel$1);
            }
            break;
    } });
}

const CosmosIconParcel = CosmosIconParcel$1;
const defineCustomElement = defineCustomElement$1;

export { CosmosIconParcel, defineCustomElement };
